import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTigercatUsers } from '../../../actions/tigercat-burns/tigercat-base-actions';
import { getFarmProjects, getRofUsers, addUserToProject } from '../../../actions/rof-burns/rof-actions';
import {
    TableContainer,
    Button,
    Table,
    TableHead,
    TableCell,
    TableRow,
    Paper,
    TableBody,
    Modal,
    Box,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from '@mui/material';
import BannerHeader from '../rofburns/shared-components/BannerHeader';

export default function Users({ userType }) {
    const dispatch = useDispatch();
    // const tigercatUsers = useSelector(state => state.tigercatBurnsBaseReducer.tigercatBurnsUsers?.data);
    const userData = useSelector(state => state.auth.userData);
    const rofUsers = useSelector(state => state.rofBurnsReducer.rofBurnsUsers);
    const farmProjects = useSelector(state => state.rofBurnsReducer.farmProjects);

    const [openModal, setOpenModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedProject, setSelectedProject] = useState('');

    useEffect(() => {
        if (userType.isTigercatBurnsUser) {
            dispatch(getTigercatUsers());
        } else {
            dispatch(getRofUsers(userData?.farmId));
            dispatch(getFarmProjects(userData?.farmId));
        }
    }, [dispatch, userType, userData]);

    const handleOpenModal = (user) => {
        setSelectedUser(user);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedUser(null);
        setSelectedProject('');
    };

    const handleAddUserToProject = () => {
        if (selectedUser && selectedProject) {
            dispatch(addUserToProject(selectedProject, selectedUser)).then(() => {
                dispatch(getRofUsers(userData?.farmId));
            })
            handleCloseModal();
        }
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <BannerHeader>Users</BannerHeader>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant='h6'>User List</Typography>
                    <Typography>Existing users are listed below. Add new users with the "Add User to Project" button.</Typography>
                </Box>
                <TableContainer component={Paper} sx={{ height: 'auto' }}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">ID</TableCell>
                                <TableCell align="left">Email</TableCell>
                                <TableCell align="left">Company</TableCell>
                                <TableCell align="left">Role</TableCell>
                                {rofUsers?.data?.length &&
                                    <TableCell align="left">Projects</TableCell>
                                }
                                <TableCell align="left">Add User</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rofUsers?.data?.map((data, index) => (
                                <TableRow key={index}>
                                    <TableCell align="left">{data.id}</TableCell>
                                    <TableCell align="left">{data.user.email}</TableCell>
                                    <TableCell align="left">{data.user.farm}</TableCell>
                                    <TableCell align="left">{data.user.isAdmin ? 'Admin' : 'User'}</TableCell>
                                    <TableCell align="left">
                                        {/* {data?.user?.projects?.map((project) => project.nickname).join(', ')} */}
                                        <Box component='ul'>
                                            {data?.user?.projects?.map((project, index) => (
                                                <Box
                                                    key={index}
                                                    component='li'>
                                                    {project.nickname}
                                                </Box>
                                            ))}
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenModal(data.id)}
                                        >
                                            Add User to Project
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            {/* Modal for Adding User to Project */}
            <Modal open={openModal} onClose={handleCloseModal}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                    }}
                >
                    <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                        Add User to Project
                    </Typography>
                    {/* {console.log(farmProjects, 'farmProjects')} */}
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel id="project-select-label">Select Project</InputLabel>
                        <Select
                            labelId="project-select-label"
                            value={selectedProject}
                            onChange={(e) => setSelectedProject(e.target.value)}
                        >
                            {farmProjects?.projects?.map((project) => (
                                <MenuItem key={project.id} value={project.id}>
                                    {project.nickname || project.projectId}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={handleAddUserToProject}
                        disabled={!selectedProject}
                    >
                        Add User
                    </Button>
                </Box>
            </Modal>
        </Box>
    );
}